export const footerContent = {
  brandName: 'Avimar Ship Chandlers',
  tagline: 'Soluciones portuarias, marítimas e industriales desde 1975.',
  description:
    'Empresa multimodal mexicana con presencia en los 13 principales puertos del país. Avituallamiento, lanchaje, almacenamiento, reparaciones y agencia consignataria.',
  address: {
    street: 'Calzada al Sumidero S/N, Zona Industrial',
    city: 'Coatzacoalcos',
    state: 'Veracruz',
    zip: '96400',
    country: 'México',
  },
  contact: {
    phone: '+52 921 218 3400',
    email: 'contacto@avimarshipchandlers.com',
    hours: '24 horas / 7 días',
  },
  navigation: {
    title: 'Navegación',
    links: [
      { label: 'Inicio', href: '/' },
      { label: 'Quiénes Somos', href: '/about' },
      { label: 'Servicios', href: '/services' },
      { label: 'Catálogo', href: '/supplies' },
      { label: 'Contacto', href: '/contact' },
    ],
  },
  services: {
    title: 'Servicios',
    links: [
      { label: 'Avituallamiento', href: '/services' },
      { label: 'Lanchaje', href: '/services' },
      { label: 'Reparaciones Navales', href: '/services' },
      { label: 'Almacenamiento', href: '/services' },
      { label: 'Recolección de Residuos', href: '/services' },
    ],
  },
  ports: {
    title: 'Puertos de Cobertura',
    pacific: ['Manzanillo', 'Salina Cruz', 'Lázaro Cárdenas'],
    gulf: ['Altamira', 'Tampico', 'Tuxpan', 'Veracruz', 'Coatzacoalcos', 'Pajaritos', 'Dos Bocas', 'Cd. del Carmen', 'Progreso'],
  },
  newsletter: {
    title: 'Mantente informado',
    placeholder: 'Tu correo electrónico',
    button: 'Suscribirse',
    hint: 'Recibe noticias de operaciones y actualizaciones de cobertura portuaria.',
  },
  cta: {
    headline: 'Tu operación no espera. Nosotros tampoco.',
    subheadline: 'Cotiza tu aprovisionamiento en menos de 1 hora.',
    button: 'Solicitar Cotización 24/7',
  },
  legal: {
    copyright: '© 2026 Avimar Ship Chandlers. Todos los derechos reservados.',
    links: [
      { label: 'Aviso de Privacidad', href: '/privacy' },
      { label: 'Términos de Servicio', href: '/terms' },
    ],
  },
  brandMarquee: 'AVIMAR SHIP CHANDLERS',
};